//import 'babel-polyfill'
import {createApp} from 'vue'
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'
// 
import App from './App.vue'
import router from './router'
import store from '@/store/index.js'


import * as echarts from 'echarts'


import * as ElIconModules from '@element-plus/icons-vue'
import { transElIconName } from '@/utils/common' 

const app = createApp(App)

app.config.globalProperties.$echarts = echarts

for(let iconName in ElIconModules){
  app.component(iconName,ElIconModules[iconName])
}

app.use(ElementPlus).use(store).use(router).mount('#app')

